import iconTicketSvg from './icon_ticket.svg';
import '../quiz_screen.css';
import './Header.css';

/** Figma header (162:24002) — CSS title + «+1» outline + ticket icon. */
export function Header() {
  return (
    <div
      className="quiz-header-text quiz-outlined-text"
      role="img"
      aria-label="Правильно ответь на вопрос, чтобы заработать +1"
    >
      <div className="quiz-header-text__line1">Правильно ответь на вопрос,</div>
      <div className="quiz-header-text__line2">
        <span>чтобы заработать</span>
        <span className="quiz-header-plus-one">+1</span>
        <img
          className="quiz-header-ticket-icon"
          src={iconTicketSvg}
          alt=""
          aria-hidden
          draggable={false}
        />
      </div>
    </div>
  );
}
